(function () {
  'use strict';

  var runtimeKey = '__msphFoundationRuntime';
  if (window[runtimeKey]) {
    window[runtimeKey].init(document);
    return;
  }

  var instances = new Map();

  function initFoundation(root) {
    if (!root || instances.has(root)) return;
    root.dataset.msphReady = 'true';
    root.classList.add('msph-js');

    var destroyed = false;
    var cleanups = [];
    var cancelIdle = null;

    function listen(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      cleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function destroy() {
      if (destroyed) return;
      destroyed = true;
      cleanups.forEach(function (cleanup) { cleanup(); });
      cleanups = [];
      delete root.dataset.msphReady;
      root.classList.remove('msph-js');
      instances.delete(root);
    }

    instances.set(root, { destroy: destroy });

    var carousels = Array.prototype.slice.call(root.querySelectorAll('[data-msph-carousel]'));

    function initCarousel(carousel) {
      if (!carousel || carousel.dataset.msphCarouselReady === 'true') return;
      carousel.dataset.msphCarouselReady = 'true';
      cleanups.push(function () { delete carousel.dataset.msphCarouselReady; });

      var viewport = carousel.querySelector('[data-msph-carousel-viewport]');
      var track = carousel.querySelector('[data-msph-carousel-track]');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-msph-slide]'));
      var prev = carousel.querySelector('[data-msph-carousel-prev]');
      var next = carousel.querySelector('[data-msph-carousel-next]');
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-msph-carousel-dot]'));
      var count = carousel.querySelector('[data-msph-carousel-count]');
      var activeIndex = 0;
      var scrollTimer = null;
      var touchStartX = 0;
      var touchStartY = 0;
      var originalTabIndexes = new WeakMap();
      var focusableSelector = 'a[href], button, input, select, textarea, summary, iframe, [tabindex], [contenteditable="true"]';
      var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var mobileLayout = window.matchMedia ? window.matchMedia('(max-width: 699px)') : null;

      if (!viewport || !track || !slides.length) return;

      cleanups.push(function () {
        cancelScrollUpdate();
        slides.forEach(function (slide) {
          slide.querySelectorAll(focusableSelector).forEach(function (element) {
            if (!originalTabIndexes.has(element)) return;
            var authoredTabIndex = originalTabIndexes.get(element);
            if (authoredTabIndex === null) element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', authoredTabIndex);
            originalTabIndexes.delete(element);
          });
        });
      });

      function slideLeft(slide) {
        return slide.offsetLeft - track.offsetLeft;
      }

      function normalizeIndex(index) {
        if (index < 0) return slides.length - 1;
        if (index >= slides.length) return 0;
        return index;
      }

      function updateState(index) {
        activeIndex = normalizeIndex(index);
        var focusWillBeHidden = slides.some(function (slide, slideIndex) {
          return slideIndex !== activeIndex && slide.contains(document.activeElement);
        });
        if (focusWillBeHidden) {
          var focusTarget = dots[activeIndex] || next || prev;
          if (!focusTarget) {
            carousel.setAttribute('tabindex', '-1');
            focusTarget = carousel;
          }
          focusTarget.focus({ preventScroll: true });
        }
        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.toggleAttribute('inert', !isActive);
          // Preserve authored tabindex values for browsers without native inert support.
          slide.querySelectorAll(focusableSelector).forEach(function (element) {
            if (!isActive) {
              if (!originalTabIndexes.has(element)) {
                originalTabIndexes.set(element, element.getAttribute('tabindex'));
              }
              element.setAttribute('tabindex', '-1');
            } else if (originalTabIndexes.has(element)) {
              var authoredTabIndex = originalTabIndexes.get(element);
              if (authoredTabIndex === null) element.removeAttribute('tabindex');
              else element.setAttribute('tabindex', authoredTabIndex);
              originalTabIndexes.delete(element);
            }
          });
        });
        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        if (count) count.textContent = (activeIndex + 1) + ' / ' + slides.length;
      }

      function cancelScrollUpdate() {
        window.clearTimeout(scrollTimer);
        scrollTimer = null;
      }

      function goTo(index, options) {
        cancelScrollUpdate();
        var settings = options || {};
        var nextIndex = normalizeIndex(index);
        updateState(nextIndex);
        if (settings.scroll === false || (mobileLayout && mobileLayout.matches)) return;
        viewport.scrollTo({
          left: slideLeft(slides[nextIndex]),
          behavior: settings.instant || (reducedMotion && reducedMotion.matches) || root.getAttribute('data-motion') !== 'true' ? 'auto' : 'smooth'
        });
      }

      function indexFromScroll() {
        var left = viewport.scrollLeft;
        var closestIndex = 0;
        var closestDistance = Infinity;

        slides.forEach(function (slide, index) {
          var distance = Math.abs(slideLeft(slide) - left);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      if (prev) {
        listen(prev, 'click', function () {
          goTo(activeIndex - 1);
        });
      }

      if (next) {
        listen(next, 'click', function () {
          goTo(activeIndex + 1);
        });
      }

      dots.forEach(function (dot) {
        listen(dot, 'click', function () {
          goTo(Number(dot.getAttribute('data-slide-index') || 0));
        });
      });

      listen(viewport, 'touchstart', function (event) {
        var touch = event.touches && event.touches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      listen(viewport, 'touchend', function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch || !window.matchMedia || !window.matchMedia('(max-width: 699px)').matches) return;

        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);

        if (absX < 48 || absX < absY * 1.35) return;
        goTo(activeIndex + (deltaX < 0 ? 1 : -1));
      }, { passive: true });

      listen(viewport, 'scroll', function () {
        cancelScrollUpdate();
        if (mobileLayout && mobileLayout.matches) return;
        scrollTimer = window.setTimeout(function () {
          scrollTimer = null;
          if (destroyed || (mobileLayout && mobileLayout.matches)) return;
          updateState(indexFromScroll());
        }, 80);
      }, { passive: true });

      listen(carousel, 'keydown', function (event) {
        if (event.defaultPrevented) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });

      listen(root, 'shopify:block:select', function onBlockSelect(event) {
        var selectedSlide = event.target && event.target.closest && event.target.closest('[data-msph-slide]');
        if (!selectedSlide || !carousel.contains(selectedSlide)) return;
        goTo(Number(selectedSlide.getAttribute('data-slide-index') || 0), { instant: true });
      });

      function onLayoutChange() {
        cancelScrollUpdate();
        goTo(activeIndex, { instant: true });
      }
      if (mobileLayout && mobileLayout.addEventListener) {
        listen(mobileLayout, 'change', onLayoutChange);
      } else if (mobileLayout && mobileLayout.addListener) {
        mobileLayout.addListener(onLayoutChange);
        cleanups.push(function () { mobileLayout.removeListener(onLayoutChange); });
      }

      goTo(0, { scroll: false });
    }

    carousels.forEach(initCarousel);

    var cancelFrame = scheduleFrame(function () {
      if (destroyed) return;
      initReveal();
      cancelIdle = scheduleIdle(function () {
        if (destroyed) return;
        initRoutes();
        initHotspots();
      });
    });
    cleanups.push(function () {
      cancelFrame();
      if (cancelIdle) cancelIdle();
    });

    function initReveal() {
      var allowMotion = root.getAttribute('data-motion') === 'true';
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var revealItems = Array.prototype.slice.call(root.querySelectorAll('[data-msph-reveal]'));

      function showAll() {
        revealItems.forEach(function (item) {
          item.classList.add('is-visible');
        });
      }

      if (!allowMotion || reducedMotion || !('IntersectionObserver' in window)) {
        showAll();
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        if (destroyed) return;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      cleanups.push(function () { observer.disconnect(); });

      revealItems.forEach(function (item, index) {
        item.style.transitionDelay = Math.min(index * 24, 160) + 'ms';
        observer.observe(item);
      });
    }

    function initRoutes() {
      var routeCards = Array.prototype.slice.call(root.querySelectorAll('[data-msph-route]'));

      function setActiveRoute(route) {
        routeCards.forEach(function (card) {
          card.classList.toggle('is-active', card === route);
        });
      }

      routeCards.forEach(function (route) {
        listen(route, 'pointerenter', function () {
          setActiveRoute(route);
        }, { passive: true });
        listen(route, 'focusin', function () {
          setActiveRoute(route);
        });
      });

      if (routeCards.length) setActiveRoute(routeCards[0]);
    }

    function initHotspots() {
      var hotspots = Array.prototype.slice.call(root.querySelectorAll('[data-msph-hotspot]'));
      var hotspotCards = Array.prototype.slice.call(root.querySelectorAll('[data-msph-hotspot-card]'));

      function setActiveHotspot(id) {
        hotspots.forEach(function (hotspot) {
          hotspot.classList.toggle('is-active', hotspot.getAttribute('data-target') === id);
        });
        hotspotCards.forEach(function (card) {
          card.classList.toggle('is-active', card.getAttribute('data-msph-hotspot-card') === id);
        });
      }

      hotspots.forEach(function (hotspot) {
        listen(hotspot, 'click', function () {
          setActiveHotspot(hotspot.getAttribute('data-target'));
        });
      });

      if (hotspots.length) setActiveHotspot(hotspots[0].getAttribute('data-target'));
    }
  }

  function scheduleFrame(callback) {
    if ('requestAnimationFrame' in window) {
      var frameId = window.requestAnimationFrame(callback);
      return function () { window.cancelAnimationFrame(frameId); };
    }
    var timeoutId = window.setTimeout(callback, 0);
    return function () { window.clearTimeout(timeoutId); };
  }

  function scheduleIdle(callback) {
    if ('requestIdleCallback' in window) {
      var idleId = window.requestIdleCallback(callback, { timeout: 700 });
      return function () { window.cancelIdleCallback(idleId); };
    }
    var timeoutId = window.setTimeout(callback, 90);
    return function () { window.clearTimeout(timeoutId); };
  }

  function initWithin(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-ms-premium-home]')) initFoundation(scope);
    scope.querySelectorAll('[data-ms-premium-home]').forEach(initFoundation);
  }

  function initAll() {
    initWithin(document);
  }

  function onSectionLoad(event) {
    initWithin(event && event.target);
  }

  function onSectionUnload(event) {
    var scope = event && event.target;
    if (!scope) return;
    instances.forEach(function (instance, root) {
      if (scope === root || scope.contains(root)) instance.destroy();
    });
  }

  window[runtimeKey] = { init: initWithin };
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
